import { gql } from '@apollo/client';

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      email
      image
      isConfirmed
      role
      suspended
      type
      FCMtoken
      userId
      username
      monday
      tuesday
      thursday
      wednesday
      friday
      saturday
      sunday
      night
      hours
      readedAt
      __typename
      com {
        userId
      }
    }
  }
  `;

  export const updateAgendaUser = gql/* GraphQL */ `
  mutation UpdateAgendaUser(
    $condition: ModelAgendaUserConditionInput
    $input: UpdateAgendaUserInput!
  ) {
    updateAgendaUser(condition: $condition, input: $input) {
      comId
      createdAt
      email
      isConfirmed
      language
      password
      phoneNumber
      profileOwner
      readedAt
      role
      suspended
      type
      updatedAt
      userId
      username
      __typename
    }
  }
  `;

export const createAgendaCompany = gql/* GraphQL */ `
mutation CreateAgendaCompany(
  $condition: ModelAgendaCompanyConditionInput
  $input: CreateAgendaCompanyInput!
) {
  createAgendaCompany(condition: $condition, input: $input) {
    account_type
    address
    comId
    createdAt
    customer_id
    name
    phoneNumber
    suspended
    type
    updatedAt
    userId
    subscriptionId
    planId
    __typename
  }
}
`;

export const updateAgendaCompany = gql/* GraphQL */ `
mutation UpdateAgendaCompany(
  $condition: ModelAgendaCompanyConditionInput
  $input: UpdateAgendaCompanyInput!
) {
  updateAgendaCompany(condition: $condition, input: $input) {
    account_type
    address
    comId
    createdAt
    customer_id
    name
    phoneNumber
    planId
    subscriptionId
    suspended
    type
    updatedAt
    userId
    __typename
  }
}
`;

export const comByUserId = gql/* GraphQL */ `
query ComByUserId(
  $filter: ModelAgendaCompanyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  comByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      account_type
      address
      comId
      createdAt
      customer_id
      name
      phoneNumber
      suspended
      type
      updatedAt
      userId
      subscriptionId
      planId
      __typename
    }
    nextToken
    __typename
  }
}
`;